<template>
  <Modal :title="t('organization.edit.tabs.users.new.title')">
    <ModalCloseButton :to="{ name: 'OrganizationsEdit' }" />
    <div class="form__input-wrapper">
      <label>{{ t('organization.edit.tabs.users.new.email') }}</label>
      <input v-model="formData.email" type="text" />
    </div>
    <div class="form__input-wrapper">
      <label>{{ t('organization.edit.tabs.users.new.position') }}</label>
      <input v-model="formData.role" type="text" />
    </div>
    <ModalSaveButton @click="save()">
      {{ t('organization.edit.tabs.users.new.submit') }}
    </ModalSaveButton>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import router from '@/routes'
import Modal from '@/components/Modal'
import ModalCloseButton from '@/components/ModalCloseButton'
import ModalSaveButton from '@/components/ModalSaveButton'

export default {
  name: 'OrganizationUsersNew',
  components: {
    Modal,
    ModalCloseButton,
    ModalSaveButton,
  },
  data() {
    return {
      formData: {
        email: '',
        role: '',
      },
    }
  },
  methods: {
    save() {
      this.createOrganizationUserInvite(this.formData)
        .then(() => {
          router.push({ name: 'OrganizationsEdit' })
          this.showFlashMessage({
            message:
              this.t('flash_messages.user') +
              this.t('flash_messages.create.success'),
          })
          this.fetchOrganizationUsers()
        })
        .catch(e => {
          this.showFlashMessage({
            message:
              this.t('flash_messages.user') +
              this.t('flash_messages.create.error'),
          })
        })
    },
    ...mapActions([
      'showFlashMessage',
      'createOrganizationUserInvite',
      'fetchOrganizationUsers',
    ]),
  },
}
</script>
